import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Play, ExternalLink, Clock, Users } from 'lucide-react';
import Navbar from '../components/Navbar';
import ReactPlayer from 'react-player/youtube';

const Guide = () => {
  const videoUrl = 'https://www.youtube.com/watch?v=tW-vpSNrs6M';

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar currentPage="guide" />

      <div className="max-w-6xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="p-3 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 shadow-lg">
              <Play className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-4xl font-bold text-gray-900">
              Platform Tutorial
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Watch our comprehensive video tutorial to learn how to use the Clinical training simulation Platform effectively
          </p>
        </div>

        {/* Main Video Section */}
        <Card className="bg-white border border-gray-200 shadow-2xl mb-8">
          <CardHeader className="text-center pb-6">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="flex items-center gap-2 px-3 py-1 bg-blue-100 rounded-full">
                <Clock className="w-4 h-4 text-blue-600" />
                <span className="text-sm font-medium text-blue-700">Complete Tutorial</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1 bg-green-100 rounded-full">
                <Users className="w-4 h-4 text-green-600" />
                <span className="text-sm font-medium text-green-700">For All Users</span>
              </div>
            </div>
            <CardTitle className="text-2xl text-gray-900 mb-2">
              How to Use the Clinical training simulation Platform
            </CardTitle>
            <p className="text-gray-600">
              Learn everything you need to know about navigating sessions, adding comments, using evaluation tools, and collaborating with other medical professionals.
            </p>
          </CardHeader>

          <CardContent className="p-6">
            {/* Video Player Container */}
            <div className="relative rounded-xl overflow-hidden shadow-lg bg-black">
              <div className="aspect-video">
                <ReactPlayer
                  url={videoUrl}
                  width="100%"
                  height="100%"
                  controls
                  light={false}
                  pip={true}
                />
              </div>
            </div>

            {/* Video Actions */}
            <div className="flex justify-center mt-6">
              <Button
                onClick={() => window.open(videoUrl, '_blank')}
                className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 px-8"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Watch on YouTube
              </Button>
            </div>
          </CardContent>
        </Card>


        {/* Need Help Section */}
        <Card className="mt-8 bg-gradient-to-r from-gray-50 to-blue-50 border-gray-200">
          <CardContent className="p-8 text-center">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Need Additional Help?
            </h3>
            <p className="text-gray-600 mb-6">
              If you have questions after watching the tutorial, don't hesitate to reach out for support.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="outline" className="border-blue-200 text-blue-700 hover:bg-blue-50">
                Contact Support
              </Button>
              <Button variant="outline" className="border-green-200 text-green-700 hover:bg-green-50">
                View Documentation
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Guide; 